import { GetObjectCommand } from '@aws-sdk/client-s3'
import { cache } from 'react'
import { captureException } from '@sentry/nextjs'
import { getS3Client } from '../../utils/s3-client'
import type { S3Client } from '@aws-sdk/client-s3'
import type { S3ClientCredentials } from '../../utils/s3-client'

const BUCKET_NAME = 'ktmine'

const uncachedFetchFromS3 = async (key: string, s3Client: S3Client) => {
  const command = new GetObjectCommand({
    Bucket: BUCKET_NAME,
    Key: key,
  })

  const data = await s3Client.send(command)
  const bodyContent = (await data.Body?.transformToString()) ?? ''
  return JSON.parse(bodyContent) as unknown
}

const fetchFromS3 = cache(uncachedFetchFromS3)

export const fetchPatentsFromS3 = async (
  documents: Array<{
    jurisdiction: string
    publicationDate: string | null
    kind: string
    documentNumber: string
  }>,
  credentials: S3ClientCredentials
): Promise<unknown[]> => {
  const keyPrefix = 'patent-document'
  const s3Client = getS3Client(credentials)

  const promises = documents
    .filter((document) => document.publicationDate !== null)
    .map(async ({ jurisdiction, publicationDate, kind, documentNumber }) => {
      try {
        const publicationYear = new Date(publicationDate!).getFullYear()
        const key = `${keyPrefix}/${jurisdiction}/${publicationYear}/${kind}/${documentNumber}.json`
        return await fetchFromS3(key, s3Client)
      } catch (error) {
        captureException(error)
        return null
      }
    })

  const results = await Promise.allSettled(promises)

  return results
    .filter(
      (result): result is PromiseFulfilledResult<unknown> =>
        result.status === 'fulfilled' && result.value !== null
    )
    .map((result) => result.value)
}
